import styled from "styled-components";

export const PercentageContainer = styled.div`
  h3 {
    margin: 10px 0;
    text-align: center;
  }
`;

export const PercentageAnalysis = styled.div<{
  greenTeam: number;
  draw: number;
  blueTeam: number;
}>`
  display: flex;
  justify-content: center;
  div {
    height: 20px;
    display: flex;
    align-items: center;
  }
  p {
    font-size: 0.9rem;
  }
  div:nth-of-type(1) {
    p {
      margin-left: 5px;
    }
    flex-basis: ${(props) => props.greenTeam}%;
    width: ${(props) => props.greenTeam}%;
    background-color: #325176;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    justify-content: flex-start;
  }
  div:nth-of-type(2) {
    p {
      color: #000;
      text-align: center;
    }
    flex-basis: ${(props) => props.draw}%;
    width: ${(props) => props.draw}%;
    background-color: #fff;
    justify-content: center;
  }
  div:last-child {
    p {
      margin-right: 5px;
      text-align: right;
    }
    flex-basis: ${(props) => props.blueTeam}%;
    width: ${(props) => props.blueTeam}%;
    justify-content: flex-end;
    background-color: #993232;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`;